export default function InstrucoesCSV() {
    return(
        <div>
            <h3>A coluna associação deve ser preenchida em letras maiusculas e sem acentos</h3>
            <h3>A coluna CPF deve ser preenchida sem pontos ou traços</h3>
        </div>
    )
}